import React, { useState } from 'react'
import logo from '../../../images/logo2.png'
import { useNavigate } from 'react-router-dom'

const Connexion = ({ _signIn, handleChange, values, _forgotPassword }) => {
    let navigate = useNavigate()
    
    return (
        <div>
            <div className='text-center mx-auto w-50 mt-4'>
                <img src={logo} className='img-fluid' alt='image du logo' />
            </div>
            <div className='mt-5'>
                <label className='form-label'>Adresse email</label>
                <input type="email" className='form-control' value={values.email} name='email' onChange={handleChange} />
            </div>
            <div className='mt-3'>
                <label className='from-label'>Mot de passe</label>
                <input type="password" className='form-control' value={values.password} name='password' onChange={handleChange} />
            </div>
            <div className='text-center mt-5'>
                <div className='btn btn-outline-info' onClick={() => [_signIn(values.email, values.password), navigate('/')]} >CONNEXION</div>
            </div>
            <div className='text-center mt-3' style={{cursor:'pointer'}} onClick={() => _forgotPassword(values.email)}>Mot de passe oublié</div>
            <div className='mt-5'>
                <div onClick={() => navigate('/nomEntreprise')}>link</div>
            </div>
        </div>
    )
}

export default Connexion

